import { api, helpers } from "../../../utils";
const { stored } = api.net.config;
const cafe = {
    sms: {
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;

const create = async (_, payload) => {
    const p = new Promise(async (resolve) => {
        hlog.start("authen.qrcode.create", "start", payload);
        if (!payload || !Array.isArray(payload.data) || !payload.props) return resolve({ error: cafe.sms.invalid_inputs });
        let res_create = await api.node.origin.qrcode.create(payload);
        resolve(res_create);
    });

    return p;
};

export default {
    create,
};



// WEBPACK FOOTER //
// src/store/authen/qrcode/actions.js